import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import '@fortawesome/fontawesome-free/css/all.min.css';


import Header from './resources/templates/fragments/Header';
import Footer from './resources/templates/fragments/Footer';
import Aside from './resources/templates/fragments/Aside';


import Inicio from './resources/templates/Inicio';
import Login from './resources/templates/Login';
import Productos from './resources/templates/Productos';
import Reseñas from './resources/templates/Reseñas';
import Aboutus from './resources/templates/Aboutus';
import ShoppingCart from './resources/templates/ShoppingCart';



import DashboardProductos from './resources/templates/DashboardProductos';
import DashboardContactanos from './resources/templates/DashboardContactanos';
import DashboardReseñas from './resources/templates/DashboardResenas';


import DashboardUsuarios from './resources/templates/administration/DashboardUsuarios';
import DashboardAlmacen from './resources/templates/administration/DashboardAlmacen';
import DashboardKardex from './resources/templates/administration/DashboardKardex';
import DashboardVentas from './resources/templates/administration/DashboardVentas';
import DashboardRegistrarVentas from './resources/templates/administration/DashboardRegistrarVentas';
import DashboardCompras from './resources/templates/administration/DashboardCompras';
import DashboardRegistrarCompras from './resources/templates/administration/DashboardRegistrarCompras';
import DashboardRegistrarCotizacion from './resources/templates/administration/DashboardRegistrarCotizacion';
import DashboardReportes from './resources/templates/administration/DashboardReportes';
import DashboardClientes from './resources/templates/administration/DashboardClientes';


import ProtectedRoute from './components/ProtectedRoute';

function AppContent() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  
  const location = useLocation();
  const isDashboard = location.pathname.toLowerCase().startsWith('/dashboard');

  return (
    <div className="App">
      {isDashboard && (
        <>
          <button className="menu-button-flotante" onClick={toggleMenu}>
            <i className={`fa-solid ${isMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
          </button>
          {isMenuOpen && <div className="sidebar-overlay" onClick={toggleMenu}></div>}
        </>
      )}

      <Routes>
        {/* --- RUTAS PÚBLICAS --- */}
        <Route path="/*" element={
          <>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Inicio />} />
                <Route path="/login" element={<Login />} />
                <Route path="/productos" element={<Productos />} />
                <Route path="/reseñas" element={<Reseñas />} />
                <Route path="/aboutus" element={<Aboutus />} />
                <Route path="/carrito/ver" element={<ShoppingCart />} />
                <Route path="/carrito/ver/:uuid" element={<ShoppingCart />} />
              </Routes>
            </main>
            <Footer />
          </>
        } />

        {/* --- RUTAS PRIVADAS (PROTEGIDAS) --- */}
        {/* Usamos un solo bloque para envolver todas las rutas de Dashboard */}

        <Route 
          path="/DashboardContactanos" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardContactanos /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/DashboardReseñas" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardReseñas /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/DashboardProductos" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardProductos /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


        <Route 
          path="/DashboardReportes" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardReportes /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


        <Route 
          path="/DashboardUsuarios" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardUsuarios /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/DashboardAlmacen" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardAlmacen /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


        <Route 
          path="/DashboardKardex" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardKardex /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


        <Route 
          path="/DashboardVentas" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardVentas /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/DashboardRegistrarVentas" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardRegistrarVentas /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


        <Route 
          path="/DashboardCompras" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardCompras/></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


        <Route 
          path="/DashboardRegistrarCompras" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardRegistrarCompras /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


        <Route 
          path="/DashboardRegistrarCotizacion" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardRegistrarCotizacion /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


        <Route 
          path="/DashboardClientes" 
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Aside isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
                <div className="flex-grow-1"><main className="p-4"><DashboardClientes /></main></div>
              </div>
            </ProtectedRoute>
          } 
        />


      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;